"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharCount = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var ui_text_1 = require("@hopin-team/ui-text");
var ui_visually_hidden_1 = require("@hopin-team/ui-visually-hidden");
var react_1 = tslib_1.__importDefault(require("react"));
var get_color_1 = require("./get-color");
var CharCount = function (_a) {
    var className = _a.className, id = _a.id, maxCount = _a.maxCount, _b = _a.charCountText, charCountText = _b === void 0 ? 'Character count: ' : _b, currentCount = _a.currentCount, __UIScope = _a.__UIScope;
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: CharCount.name,
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    return (react_1.default.createElement(ui_text_1.Text, { className: rootClasses, id: id, pattern: "captionMedium", color: (0, get_color_1.getColor)({ currentCount: currentCount, maxCount: maxCount }) },
        react_1.default.createElement("span", null,
            react_1.default.createElement(ui_visually_hidden_1.VisuallyHidden, null, charCountText),
            currentCount,
            " / ",
            maxCount)));
};
var CharCountWithSpace = (0, ui_helper_with_space_1.withSpace)(CharCount);
exports.CharCount = CharCountWithSpace;
//# sourceMappingURL=char-count.js.map